import { forwardRef } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import {
    typoHeadingXl,
    typoHeading1,
    typoHeading2,
    typoHeading3,
    typoHeading4,
    typoHeading5,
    typoHeading6,
} from '../../../lib/styles/Typography'
import { Heading, TypoHeading } from "../../../types";

export interface HeadlineProps {
    children: React.ReactNode
    is: TypoHeading
    as?: Heading
    className?: string
    $textColor?: string
}


const StyledHeadline = styled.h1<{ $showAs: HeadlineProps['is'], $textColor?: string }>`
  ${p => p.$showAs === 'xl' && typoHeadingXl}
  ${p => p.$showAs === 'h1' && typoHeading1}
  ${p => p.$showAs === 'h2' && typoHeading2}
  ${p => p.$showAs === 'h3' && typoHeading3}
  ${p => p.$showAs === 'h4' && typoHeading4}
  ${p => p.$showAs === 'h5' && typoHeading5}
  ${p => p.$showAs === 'h6' && typoHeading6}
  color: ${p => p.$textColor || 'inherit'};
`

export const Headline = forwardRef<HTMLHeadingElement, HeadlineProps>(({ children, as, is, className, $textColor }, ref) => {
    return (
        <StyledHeadline ref={ref} as={is} $showAs={as || is} className={className} $textColor={$textColor}>
            {children}
        </StyledHeadline>
    )
})
